import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/lems-v1/images/close-black-icon.svg'


const _hoisted_1 = {
  class: "modal-dialog issuespop",
  role: "document"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "pop-issues-top" }
const _hoisted_4 = { style: {"margin":"5px 0","color":"#666","font-size":"14px"} }
const _hoisted_5 = { class: "pop-issues-content" }
const _hoisted_6 = {
  class: "nav",
  "nav-ta": "",
  id: "b",
  role: "tablist"
}
const _hoisted_7 = {
  class: "active",
  id: "nav-home-tab",
  "data-bs-toggle": "tab",
  href: "#nav-home",
  role: "tab",
  "aria-controls": "nav-home",
  "aria-selected": "true"
}
const _hoisted_8 = {
  class: "",
  id: "nav-profile-tab",
  "data-bs-toggle": "tab",
  href: "#nav-profile",
  role: "tab",
  "aria-controls": "nav-profile",
  "aria-selected": "false"
}
const _hoisted_9 = {
  class: "tab-content pop-issues-mid",
  id: "nav-tabContent"
}
const _hoisted_10 = {
  class: "tab-pane fade show active",
  id: "nav-home",
  role: "tabpanel",
  "aria-labelledby": "nav-home-tab"
}
const _hoisted_11 = { class: "right-open-issues-row" }
const _hoisted_12 = {
  key: 0,
  class: "no-data"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "open-issues-content" }
const _hoisted_16 = {
  key: 2,
  class: "pagination-box"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  class: "tab-pane fade",
  id: "nav-profile",
  role: "tabpanel",
  "aria-labelledby": "nav-profile-tab"
}
const _hoisted_19 = { class: "right-open-issues-row" }
const _hoisted_20 = {
  key: 0,
  class: "no-data"
}
const _hoisted_21 = { key: 1 }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "open-issues-content" }
const _hoisted_24 = {
  key: 2,
  class: "pagination-box"
}
const _hoisted_25 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "modal fade show",
        id: "issuesPop",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "exampleModalLabel",
        "aria-hidden": "false",
        style: {"display":"block","background-color":"rgba(0,0,0,0.5)"},
        onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.constants.CREATED_RESLOVED_ISSUES_TEXT) + " - " + _toDisplayString(_ctx.popupData.month) + " " + _toDisplayString(new Date().getFullYear()), 1),
              _createElementVNode("p", _hoisted_4, " Project: " + _toDisplayString(_ctx.popupData.projectKey), 1),
              _createElementVNode("button", {
                type: "button",
                id: "issuesPopCloseBtn",
                class: "close",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args))),
                "aria-label": "Close"
              }, [...(_cache[6] || (_cache[6] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: ""
                }, null, -1)
              ]))])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", _hoisted_7, _toDisplayString(_ctx.constants.CREATED_ISSUES_BUTTON), 1),
                _createElementVNode("button", _hoisted_8, _toDisplayString(_ctx.constants.RESOLVED_ISSUES_BUTTON), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    (_ctx.createdIssues.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("p", null, "No created issues found for " + _toDisplayString(_ctx.popupData.month) + " " + _toDisplayString(new Date().getFullYear()) + " in project " + _toDisplayString(_ctx.popupData.projectKey), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedCreatedIssues, (issue) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: issue.id
                            }, [
                              _createVNode(_component_router_link, {
                                to: `/employee/issue-detail/${issue.key}`
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("i", null, [
                                    _createElementVNode("img", {
                                      src: issue.fields.issuetype.iconUrl,
                                      alt: ""
                                    }, null, 8, _hoisted_14)
                                  ]),
                                  _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("strong", null, _toDisplayString(issue.key), 1),
                                    _createElementVNode("p", null, _toDisplayString(issue.fields.summary), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]))
                          }), 128))
                        ])),
                    (_ctx.createdTotalPages > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("ul", null, [
                            (_ctx.createdCurrentPage !== 1)
                              ? (_openBlock(), _createElementBlock("li", {
                                  key: 0,
                                  class: "pagination-first",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeCreatedPage(_ctx.createdCurrentPage - 1)))
                                }, [...(_cache[7] || (_cache[7] = [
                                  _createElementVNode("button", { id: "paginationPreButton" }, null, -1)
                                ]))]))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.createdVisiblePages, (page) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: page,
                                onClick: ($event: any) => (_ctx.changeCreatedPage(page))
                              }, [
                                _createElementVNode("a", {
                                  href: "#",
                                  class: _normalizeClass({ active: _ctx.createdCurrentPage === page })
                                }, _toDisplayString(page), 3)
                              ], 8, _hoisted_17))
                            }), 128)),
                            (_ctx.createdCurrentPage !== _ctx.createdTotalPages)
                              ? (_openBlock(), _createElementBlock("li", {
                                  key: 1,
                                  class: "pagination-last",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeCreatedPage(_ctx.createdCurrentPage + 1)))
                                }, [...(_cache[8] || (_cache[8] = [
                                  _createElementVNode("button", { id: "paginationNextButton" }, null, -1)
                                ]))]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    (_ctx.resolvedIssues.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("p", null, "No resolved issues found for " + _toDisplayString(_ctx.popupData.month) + " " + _toDisplayString(new Date().getFullYear()) + " in project " + _toDisplayString(_ctx.popupData.projectKey), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("ul", _hoisted_21, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedResolvedIssues, (issue) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: issue.id
                            }, [
                              _createVNode(_component_router_link, {
                                to: `/employee/issue-detail/${issue.key}`
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("i", null, [
                                    _createElementVNode("img", {
                                      src: issue.fields.issuetype.iconUrl,
                                      alt: ""
                                    }, null, 8, _hoisted_22)
                                  ]),
                                  _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("strong", null, _toDisplayString(issue.key), 1),
                                    _createElementVNode("p", null, _toDisplayString(issue.fields.summary), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]))
                          }), 128))
                        ])),
                    (_ctx.resolvedTotalPages > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createElementVNode("ul", null, [
                            (_ctx.resolvedCurrentPage !== 1)
                              ? (_openBlock(), _createElementBlock("li", {
                                  key: 0,
                                  class: "pagination-first",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeResolvedPage(_ctx.resolvedCurrentPage - 1)))
                                }, [...(_cache[9] || (_cache[9] = [
                                  _createElementVNode("button", { id: "paginationPreButton" }, null, -1)
                                ]))]))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resolvedVisiblePages, (page) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: page,
                                onClick: ($event: any) => (_ctx.changeResolvedPage(page))
                              }, [
                                _createElementVNode("a", {
                                  href: "#",
                                  class: _normalizeClass({ active: _ctx.resolvedCurrentPage === page })
                                }, _toDisplayString(page), 3)
                              ], 8, _hoisted_25))
                            }), 128)),
                            (_ctx.resolvedCurrentPage !== _ctx.resolvedTotalPages)
                              ? (_openBlock(), _createElementBlock("li", {
                                  key: 1,
                                  class: "pagination-last",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeResolvedPage(_ctx.resolvedCurrentPage + 1)))
                                }, [...(_cache[10] || (_cache[10] = [
                                  _createElementVNode("button", { id: "paginationNextButton" }, null, -1)
                                ]))]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}